<template id="client-details-view">
  <div>
    <AppBreadcrumbs :items="breadcrumbs" class="pl-4" />
    <v-card
      class="shadow-off"
      loader-height="2"
      :loading="loading || productloading"
      :disabled="loading || productloading"
    >
      <v-card-text class="pb-0">
        <div class="d-flex align-center">
          <v-tooltip bottom content-class="tooltip-bottom">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" class="shadow-off" icon @click="$nova.gotoLink({path: '/admin/client'})"><v-icon>mdi-arrow-left</v-icon></v-btn>
            </template>
            <span>Back</span>
          </v-tooltip>
          <v-tooltip bottom content-class="tooltip-bottom">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" class="shadow-off mr-2" icon @click="refreshData()"><v-icon>mdi-refresh</v-icon></v-btn>
            </template>
            <span>Refresh data</span>
          </v-tooltip>
          <v-spacer></v-spacer>
        </div>
      </v-card-text>
      <v-card-text class="pt-0">
        <div class="d-flex align-center mb-2">
          <div class="title mr-2">{{ data.name }}</div>
        </div>
        <div class="mb-2">
          <v-chip v-if="data.status" label color="success"><span>Active</span></v-chip>
          <v-chip v-else label color="error"><span>Inactive</span></v-chip>
          <v-chip label class="ml-2"><span>{{ data.type }}</span></v-chip>
        </div>
        <div>
          <span class="mr-1"><v-icon>mdi-account-box</v-icon></span>
          <span class="mr-4">{{ data.contactperson || "Not Available" }}</span>
          <span class="mr-1"><v-icon>mdi-email</v-icon></span>
          <span class="mr-4">{{ data.contactemail }}</span>
          <span class="mr-1"><v-icon>mdi-phone</v-icon></span>
          <span class="mr-4">{{ data.contactno }}</span>
          <span class="mr-1"><v-icon>mdi-map-marker</v-icon></span>
          <span class="mr-4">{{ data.address }}</span>
        </div>
      </v-card-text>
      <v-card-text class="pt-0 pb-0">
        <v-tabs v-model="tab" bg-color="primary" height="34">
          <v-tab :key="0" class="text-transform-none justify-start">
            <v-icon class="mr-2">mdi-account-group</v-icon>
            Users
          </v-tab>
          <v-tab :key="1" class="text-transform-none justify-start">
            <v-icon class="mr-2">mdi-apps</v-icon>
            Subscriptions
          </v-tab>
          <v-tab :key="2" class="text-transform-none justify-start">
            <v-icon class="mr-2">mdi-cogs</v-icon>
            Settings
          </v-tab>
            <v-tab v-if="data.aiEnabled" :key="3" class="text-transform-none justify-start">
            <v-icon class="mr-2">mdi-creation</v-icon>
            AI
            </v-tab>
        </v-tabs>
        <v-divider></v-divider>
      </v-card-text>
      <v-card-text>
        <v-tabs-items v-model="tab">
          <v-tab-item :key="0">
            <div class="d-flex align-center">
              <!-- <div class="pl-2 title border-left-primary font-weight-thin">
                Users
              </div> -->
              <v-btn
                class="primaryBtn"
                @click="addAccess()"
                ><v-icon>mdi-plus</v-icon><p>Associate New User</p></v-btn
              >
            </div>
            <div v-if="userlist.length > 0" class="mt-2 mb-4">
              <template v-for="(v, k) in userlist">
                <div :key="k" class="hoverable">
                  <div class="d-flex align-center py-1 px-2">
                    <v-avatar
                      size="35"
                      :style="`background-color:${colors[k % 15]}`"
                      class="font-weight-bold mr-2"
                    >
                      {{
                        (((v.user_detail || {}).name || "").split(" ") || [])
                          .slice(0, 2)
                          .map((word) => (word[0] || "").toUpperCase())
                          .join("")
                      }}
                    </v-avatar>
                    <div>
                      <div class="font-weight-bold">{{ (v.user_detail || {}).name }}</div>
                      <div>
                        <span class="mr-1"><v-icon>mdi-email</v-icon></span>
                        <span class="mr-4">{{ (v.user_detail || {}).contactemail }}</span>
                        <!-- <span class="mr-1"><v-icon>mdi-phone</v-icon></span>
                        <span class="mr-4">{{ v.contactno }}</span> -->
                      </div>
                    </div>
                    <v-spacer></v-spacer>
                    <span v-if="!v.status" label class="error--text mr-4">Access Disabled</span>
                    <v-tooltip bottom content-class="tooltip-bottom">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          v-bind="attrs"
                          v-on="on"
                          @click="editAccess(v)"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      Edit
                    </v-tooltip>
                    <v-tooltip bottom content-class="tooltip-bottom" v-if="v.status">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          v-bind="attrs"
                          v-on="on"
                          @click="enableDisableAccess(v._id, 'disable', k)"
                          ><v-icon>mdi-close</v-icon></v-btn
                        >
                      </template>
                      Disable
                    </v-tooltip>
                    <v-tooltip bottom content-class="tooltip-bottom" v-else>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          v-bind="attrs"
                          v-on="on"
                          @click="enableDisableAccess(v._id, 'enable', k)"
                          ><v-icon>mdi-check</v-icon></v-btn
                        >
                      </template>
                      Enable
                    </v-tooltip>
                    <v-tooltip bottom content-class="tooltip-bottom">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          class="mr-2"
                          v-bind="attrs"
                          v-on="on"
                          @click="
                            deleteuserdialog = true;
                            deleteuserdata = { ...v };
                          "
                          ><v-icon>mdi-cancel</v-icon></v-btn
                        >
                      </template>
                      Revok Access
                    </v-tooltip>
                  </div>
                  <v-divider></v-divider>
                </div>
              </template>
            </div>
            <div v-else class="title grey--text my-8 text-center">No user added</div>
          </v-tab-item>
          <v-tab-item :key="1">
            <div class="d-flex align-center">
              <!-- <div class="pl-2 title border-left-primary font-weight-thin">
                Users
              </div> -->
              <v-btn
                class="primaryBtn"
                @click="addSubscriptionDialog()"
                ><v-icon>mdi-plus</v-icon><p>New Subscription</p></v-btn
              >
            </div>
            <div v-if="subscriptionlist.length > 0" class="mt-2">
              <template v-for="(v, k) in subscriptionlist">
                <div :key="k" class="hoverable">
                  <div class="d-flex align-center py-1 px-2">
                    <v-avatar
                      size="35"
                      :class="`font-weight-bold mr-2 primary c${((v.product_detail || {}).solution || '').toLowerCase()} white--text`"
                    >
                      {{
                        (((v.product_detail || {}).solution || "").split(" ") || [])
                          .slice(0, 1)
                          .map((word) => (word[0] || "").toUpperCase())
                          .join("")
                      }}
                    </v-avatar>
                    <div>
                      <div class="font-weight-bold">{{ (v.product_detail || {}).name }}</div>
                      <div>
                        <span class="mr-1"><v-icon>mdi-checkbox-marked-outline</v-icon></span>
                        <span class="mr-4">{{ (v.plan_detail || {}).name }}</span>
                        <!-- <span class="mr-1"><v-icon>mdi-phone</v-icon></span>
                        <span class="mr-4">{{ v.contactno }}</span> -->
                      </div>
                    </div>
                    <v-spacer></v-spacer>
                    <div v-if="v.status" class="mr-2 success--text font-weight-bold">
                      Active
                    </div>
                    <div v-else class="mr-2 error--text font-weight-bold">
                      Inactive
                    </div>
                    <v-tooltip bottom content-class="tooltip-bottom">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          v-bind="attrs"
                          v-on="on"
                          @click="editSubscription(v)"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      Edit
                    </v-tooltip>
                    <v-tooltip bottom content-class="tooltip-bottom" v-if="v.status">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          v-bind="attrs"
                          v-on="on"
                          color="error"
                          @click="enableDisableSubscription(v._id, 'disable', k)"
                          ><v-icon>mdi-close-circle</v-icon></v-btn
                        >
                      </template>
                      Disable
                    </v-tooltip>
                    <v-tooltip bottom content-class="tooltip-bottom" v-else>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          v-bind="attrs"
                          v-on="on"
                          color="success"
                          @click="enableDisableSubscription(v._id, 'enable', k)"
                          ><v-icon>mdi-check-circle</v-icon></v-btn
                        >
                      </template>
                      Enable
                    </v-tooltip>
                  </div>
                  <v-divider></v-divider>
                </div>
              </template>
            </div>
            <div v-else class="title grey--text my-8 text-center">No subscription added</div>
          </v-tab-item>
          <v-tab-item :key="2">
            <div v-if="addflag || editflag">
              <div class="pb-4 d-flex title align-center">
                <span v-if="addflag" class="">Add New Entity</span>
                <span v-else-if="editflag" class="">Edit Entity Details</span>
                <v-spacer></v-spacer>
              </div>
              <EntityForm
                :addflag="addflag"
                :editflag="editflag"
                :modifydata.sync="modifydata"
                :errors="errors"
                :selectdata="selectdata"
                :industries="industries"
                :sectors="sectors"
                :size="size"
                :plans="plans"
                :allUsers="allUsers"
                :isEnabled.sync="isEnabled"
                @sod-switch="handleSwitchChange"
                @ai-enabled="handleAIEnabledChange"
                @user-permission-enabled="handleUserPermissionChange"
                @cancel="() => { editflag = false; }"
                @update="update"
                class="mb-10"
                :aiEnabledLoading="aiEnabledLoading"
                :userPermissionLoading="userPermissionLoading"
              />
            </div>
            <div v-else>
              <div class="pb-4 d-flex align-center">
                <span class="title">View Entity Details</span>
                <v-spacer></v-spacer>
                <v-btn
                  icon
                  @click="editflag = true; errors = {}; modifydata = { ...data }; isEnabled = !!data.sod"
                  ><v-icon>mdi-pencil</v-icon></v-btn
                >
              </div>
              <v-row>
                <v-col>
                  <template v-if="Object.keys(data).length > 0">
                    <v-card class="mb-12" outlined>
                      <v-list dense>
                        <v-list-item class="hoverable">
                          <v-list-item-icon><v-icon color="primary">mdi-account</v-icon></v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title><h4 class="font-weight-regular">{{ data.name }}</h4></v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item>
                          <v-list-item-icon><v-icon color="primary">mdi-account-box</v-icon></v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title class="mb-2"><p>Contact Person</p></v-list-item-title>
                            <v-list-item-subtitle><span>{{ data.contactperson || 'Not Available' }}</span></v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item>
                          <v-list-item-icon><v-icon color="primary">mdi-email</v-icon></v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title class="mb-2"><p>Email</p></v-list-item-title>
                            <v-list-item-subtitle><span>{{ data.contactemail }}</span></v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item>
                          <v-list-item-icon><v-icon color="primary">mdi-phone</v-icon></v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title class="mb-2"><p>Contact Number</p></v-list-item-title>
                            <v-list-item-subtitle><span>{{ data.contactno }}</span></v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item>
                          <v-list-item-icon><v-icon color="primary">mdi-map-marker</v-icon></v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title class="mb-2"><p>Address</p></v-list-item-title>
                            <v-list-item-subtitle><span>{{ data.address }}</span></v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item>
                          <v-list-item-icon><v-icon color="primary">mdi-robot</v-icon></v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title class="mb-2"><p>Gen AI</p></v-list-item-title>
                            <v-list-item-subtitle>
                              <v-chip :color="data.aiEnabled ? 'success' : 'error'">
                                <span>{{ data.aiEnabled ? 'Enabled' : 'Disabled' }}</span>
                              </v-chip>
                              <v-chip small label>
                               <span>AI Limit:{{ data.aiLimit }}</span>
                              </v-chip>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item>
                          <v-list-item-icon><v-icon color="primary">mdi-bell-ring</v-icon></v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title class="mb-2"><p>Notification</p></v-list-item-title>
                            <v-list-item-subtitle>
                              <v-chip :color="data.schedulerEnabled ? 'success' : 'error'">
                                <span>{{ data.schedulerEnabled ? 'Enabled' : 'Disabled' }}</span>
                              </v-chip>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item>
                          <v-list-item-icon><v-icon color="primary">mdi-account-lock</v-icon></v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title class="mb-2"><p>User Permission</p></v-list-item-title>
                            <v-list-item-subtitle>
                              <v-chip :color="data.user_permissions_superadmin ? 'success' : 'error'">
                                <span>{{ data.user_permissions_superadmin ? 'Enabled' : 'Disabled' }}</span>
                              </v-chip>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                         <v-list-item>
                          <v-list-item-icon><v-icon color="primary">mdi-pin</v-icon></v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title class="mb-2"><p class="text-transform-none">FBC Shortcut</p></v-list-item-title>
                            <v-list-item-subtitle>
                              <v-chip :color="data.pinCount !== -1 ? 'success' : 'error'">
                                <span>{{ data.pinCount !== -1 ? 'Enabled' : 'Disabled' }}</span>
                              </v-chip>
                              <v-chip small label>
                                <span>Pin Count: {{ data.pinCount }}</span>
                              </v-chip>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item>
                          <v-list-item-icon><v-icon color="primary">mdi-robot-outline</v-icon></v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title class="mb-2"><p class="text-transform-none">Chat bot</p></v-list-item-title>
                            <v-list-item-subtitle>
                              <v-chip :color="data.chatbotEnabled ? 'success' : 'error'">
                                <span>{{ data.chatbotEnabled ? 'Enabled' : 'Disabled' }}</span>
                              </v-chip>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </template>
                  <template v-else>
                    <v-alert type="info" :value="true" text border="left">
                      No details available
                    </v-alert>
                  </template>
                </v-col>
              </v-row>
            </div>
          </v-tab-item>
          <v-tab-item :key="3">

          <aiInfoTable 
          :key="aiTableKey"
          :aiHeaders="aiHeaders" 
          :apiUrl="url" 
          :editable="editableAi"
          :clientId="data._id"
          :clientCode="data.code"
    />
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>

    <v-dialog v-model="deleteuserdialog" max-width="600" persistent>
      <v-card
        :loading="deleteuserloading"
        :disabled="deleteuserloading"
        loader-height="2"
        class=""
      >
        <v-card-text class="primary white--text d-flex align-center py-2 px-4">
          <span class="font-size-md white--text">Revok User Access</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="deleteuserdialog = false" class="ml-2 white--text"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-card-text>
        <v-card-text class="mt-4">
          <div class="mt-4">
            <div class="mb-2">
              This will revok
              <strong
                >{{ (deleteuserdata.user_detail || {}).name }} ({{
                  (deleteuserdata.user_detail || {}).contactemail
                }})</strong
              >
              user's access from <strong>{{data.name}}</strong> client. Do you want to continue?
            </div>
          </div>
        </v-card-text>
        <v-card-text class="d-flex">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="revokeAccess()"><p>Confirm</p></v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="adduserdialog" max-width="600" persistent>
      <v-card
        :loading="adduserloading"
        :disabled="adduserloading"
        loader-height="2"
        class=""
      >
        <v-card-text class="tableHeaderBg d-flex align-center py-2 px-4">
          <span class="font-size-md" v-if="!editId"
            >Associate New User</span
          >
          <span class="font-size-md" v-else>Edit User</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="adduserdialog = false" class="ml-2"
            ><v-icon>mdi-close</v-icon></v-btn    
          >
        </v-card-text>
        <v-card-text class="mt-6">
          <lb-string
            v-model="adduserdata.email"
            label="Enter User Email"
            :error="addusererror.email"
          />
          <div class="body-2 mb-2">Select the appropriate role under each subscribed solution</div>
          <v-row>
            <v-col>
              <v-divider></v-divider>
              <div v-for="(items, i) in productList" :key="i" class="">
                <div class="hoverable px-2 py-1">
                  <div class="font-weight-bold ">
                    {{ items.name }}
                  </div>
                  <div class="error--text" v-if="Object.keys(items.role || {}).length === 0">No roles available</div>
                  <v-radio-group
                    v-else
                    v-model="selected[items._id]"
                    row
                    class="pt-0 mt-0"
                    dense
                    hide-details
                  >
                    <v-radio v-for="(v, i) in items.role" :key="i" :label="v.name" class="my-0" :value="v._id"></v-radio>
                    <v-radio label="None" value="none"></v-radio>
                  </v-radio-group>
                </div>
                <v-divider></v-divider>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text class="d-flex">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="addEditAccess()"
            ><p>Confirm</p></v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addeditsubdialog" max-width="600" persistent>
      <v-card
        :loading="addeditsubloading"
        :disabled="addeditsubloading"
        loader-height="2"
        class=""
      >
        <v-card-text class="tableHeaderBg white--text d-flex align-center py-2 px-4">
          <span class="font-size-md" v-if="editsubsid === ''"
            >Add New Subscription</span
          >
          <span class="font-size-md" v-else>Edit Subscription</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="addeditsubdialog = false" class="ml-2"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-card-text>
        <v-card-text class="mt-4">
          <div v-if="!(selectedproduct || {})._id">
            <div class="body-2 mb-2">Select a product from the list below</div>
            <div v-if="possibleproducts.length > 0">
              <template v-for="(v,k) in possibleproducts">
                <div :key="k" class="hoverable cursor-pointer" @click="selectedproduct = v">
                  <div class="pa-1">
                    <v-avatar size="25" :class="`font-weight-bold mr-2 primary c${(v.solution || '').toLowerCase()} white--text`">
                      {{
                        ((v.solution || "").split(" ") || [])
                          .slice(0, 1)
                          .map((word) => (word[0] || "").toUpperCase())
                          .join("")
                      }}
                    </v-avatar>
                    <span>{{ v.name }}</span>
                  </div>
                  <v-divider></v-divider>
                </div>
              </template>
            </div>
            <div v-else class="pt-2">
              No products available to subscribe
            </div>
          </div>
          <div  v-else-if="!(selectedplan || {})._id">
            <div class="mb-2 d-flex align-center">
              <v-btn icon class="shadow-off mr-2" v-if="editsubsid === ''" @click="selectedproduct = {};selectedplan = {};">
                <v-icon class="">mdi-arrow-left</v-icon>
              </v-btn>
              <span class="body-2">
                Select a plan from the list below for 
              </span>
              <v-chip class="ml-2 white--text" label :color="`primary c${(selectedproduct.solution || '').toLowerCase()}`"><span>{{selectedproduct.name}}</span></v-chip>
            </div>
            <div v-if="possibleplans.length > 0">
              <template v-for="(v,k) in possibleplans">
                <div :key="k" class="hoverable cursor-pointer" @click="selectedplan = v">
                  <div class="pa-1">
                    <v-avatar size="25" :class="`font-weight-bold mr-2 primary c${(selectedproduct.solution || '').toLowerCase()} white--text`">
                      {{
                        ((selectedproduct.solution || "").split(" ") || [])
                          .slice(0, 1)
                          .map((word) => (word[0] || "").toUpperCase())
                          .join("")
                      }}
                    </v-avatar>
                    <span>{{ v.name }}</span>
                    <span class="ml-2 caption">({{ v.code }})</span>
                  </div>
                  <v-divider></v-divider>
                </div>
              </template>
            </div>
            <div v-else class="pt-2">
              No plans available in this product
            </div>
          </div>
          <div v-else>
            <div class="d-flex align-center mb-2">
              <v-btn icon class="shadow-off mr-2" @click="selectedplan = {}">
                <v-icon class="">mdi-arrow-left</v-icon>
              </v-btn>
              <span class="body-2">You have selected the below plan. Do you want to proceed to add new subscription?</span>
            </div>
            <div>
              <span class="font-weight-bold">Selected Product:</span>
              <span class="ml-2">{{selectedproduct.name}}</span>
            </div>
            <div>
              <span class="font-weight-bold">Selected Plan:</span>
              <span class="ml-2">{{selectedplan.name}}</span>
            </div>

          </div>
        </v-card-text>
        <v-card-text class="d-flex">
          <v-spacer></v-spacer>
          <v-btn :disabled="!((selectedproduct || {})._id && (selectedplan || {})._id)" color="primary" @click="addEditSubscription()"
            ><p>Confirm</p></v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
// import pageHeader from '@/components/pageHeader'
// import managelist from '@/components/ManageList'

import { mapActions } from 'vuex';
// import AiDashboard from '@/modules/varianceanalysis/views/AiDashboard.vue';
import EntityForm from './components/EntityForm.vue';
import AppBreadcrumbs from '@/views/common/AppBreadcrumbs.vue';
import aiInfoTable from './components/AiInfoTable.vue'


export default {
  components: {
    // AiDashboard,
    EntityForm,
    AppBreadcrumbs,
    aiInfoTable
  },
  name: "clientv2",
  // props: ['props'],
  data: function () {
    return {
      pageprops: {
      },
      id: "",
      data: {},
      modifydata: {},
      userlist: [],
      subscriptionlist: [],
      existingproductids: [],
      tab: 0,
      subscriptionproducts: [],
      subscriptionplans: [],
      addeditsubdialog: false,
      addeditsubloading: false,
      selectedproduct: {},
      selectedplan: {},
      editsubsid: '',
      possibleproducts: [],
      possibleplans: [],
      loading: false,
      productloading: false,
      addflag: false,
      colors: [],
      deleteuserdialog: false,
      deleteuserloading: false,
      deleteuserdata: {},
      adduserdialog: false,
      adduserloading: false,
      adduserdata: {},
      addusererror: {},
      editflag: false,
      selectedindex: 0,
      formdata: {},
      errors: {},
      editId: null,
      productList: [],
      selected: {},
      listdata: [],
      selectdata: this.$store.state.selectdata,
      allUsers: [],
      industries: this.$store.state.industries || [],
      sectors: this.$store.state.sectors || {},
      size: this.$store.state.size || [],
      isEnabled:false,
      plans: this.$store.state.plans || [],
      aiEnabledLoading: false,
      userPermissionLoading: false,
      aiHeaders: [
        { text: 'Name', value: 'feature_name',sortable: false },
        { text: 'type', value: 'name',sortable: false },
        { text: 'Model', value: 'model',sortable: false },
        { text: 'Provider', value: 'provider',sortable: false },
        { text: 'Threshold', value: 'threshold',sortable: false },
        { text: 'Platform admin', value: 'platform_admin_enabled',sortable: false },
        { text: 'Super admin', value: 'super_admin_enabled',sortable: false },
        { text: 'Prompt variants', value: 'prompt_variants_data',sortable: false },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      tableData: [],
      url: '/v2/client/get-all-ai-featuresbyclient',
      
      editableAi:true,
      aiTableKey: 0,
    };
  },
  // components: {
  //   // pageHeader,managelist
  // },
  created() {
    this.refreshData();
    this.colors = this.$nova.getColors(15, 0.5);
  },
  activated() {
    this.refreshData();
  },
  mounted() {},
  methods: {
    ...mapActions('admin', ['updateUserPermission']),
    
    async GetAIData() {
      this.loading = true;
      this.error = '';
      try {
        // Send client as payload if required by API
        const response = await this.axios.post(this.url, { client: this.data._id });
        if (response.data && response.data.status === 'success') {
          this.tableData = (response.data.features || [])
        } else {
          this.tableData = [];
          this.error = response.data?.message || 'No data found';
        }
      } catch (err) {
        this.tableData = [];
        this.error = err.message || 'Error fetching data'
      } finally {
        this.loading = false;
      }
    },
    refreshData() {
      this.id = this.$route.params.id;
      this.errors = {};
      this.addflag = false;
      this.editflag = false;
      this.getData();
      this.getProductListData();
      this.GetAIData();
      // Force aiInfoTable to re-render
      this.aiTableKey++;
    },
    getData() {     
      this.loading = true;
      this.axios
        .post("/v2/client/get/" + this.id)
        .then((dt) => {
          if (dt.data.status === "success") {
            this.data = dt.data.data[0] || {};
            // this.$store.commit("setClient", this.data._id);
            // Update store flags for this client
            this.$store.commit("setAiFlag", this.data.aiEnabled || false);
            this.$store.commit("setUserPermissionFlag", this.data.user_permissions_superadmin || false);
            this.$store.commit("setComparitive1", this.data.comparitive1Enabled || false);
            this.$store.commit("setComparitive2", this.data.comparitive2Enabled || false);
            this.$store.commit("setPinCount", this.data.pinCount ?? -1);
            this.$store.commit("setChatbotEnabled", this.data.chatbotEnabled || false);

            return this.axios.post("/v2/userpermission/userlist/"+this.data._id, {
            });
          } else throw new Error(dt.data.message || "Error fetching data");
        })
        .then((dt) => {
          if (dt.data.status === "success") {
            this.userlist = dt.data.data;
            return this.axios.post("/v2/subscription/subscribed/allsubscriptions/"+this.data._id);
          } else throw new Error(dt.data.message || "Error reading userlist");
        })
        .then((dt) => {
          if (dt.data.status === "success") {
            this.subscriptionlist = dt.data.data;
            this.existingproductids = [];
            for (const i of this.subscriptionlist) {
              this.existingproductids.push((i.product_detail || {})._id);
            }
            return this.axios.post("/v2/subscription/subscribed/formdata");
          } else throw new Error(dt.data.message || "Error reading subscription list");
        })
        .then((dt) => {
          if (dt.data.status === "success") {
            this.subscriptionproducts = (dt.data.data[0] || {}).product || [];
            this.subscriptionplans = (dt.data.data[0] || {}).plan || [];
            // let existingproducts = [];
            // for (const i of subscriptionlist) {
            //   existingproducts.push(i.product_detail._id);
            // }
            // let products = (dt.data.data[0] || {}).product || [];
            // let plans = (dt.data.data[0] || {}).plan || [];
            // let newproducts = [];
            // let newplans = [];
            // for (const i of products) {
            //   if(existingproducts.indexOf(i._id) === -1) newproducts.push(i);
            // }
            // for (const i of plans) {
            //   if(newproducts.indexOf(i.product) > -1) newplans.push(i);
            // }
            // this.newsubscriptionproducts = newproducts;
            // this.newsubscriptionplans = newplans;
          } else throw new Error(dt.data.message || "Error reading subscription list");
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getProductListData() {
      this.productloading = true;
      this.axios
        .post("/v2/userpermission/getformdata/" + this.id)
        .then((ele) => {
          if (ele.data.status === "success") {
            this.productList = ele.data.data;
          } else throw new Error(ele.data.message || "Error fetching data");
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        })
        .finally(() => {
          this.productloading = false;
        });
    },
    addSubscriptionDialog() {
      this.selectedproduct = {};
      this.selectedplan = {};
      this.editsubsid = '';
      this.addeditsubdialog = true;
      this.possibleproducts = [];
      for (const i of this.subscriptionproducts) {
        if(this.existingproductids.indexOf(i._id) === -1 && i.code !== "admin") this.possibleproducts.push(i);
      }
      // this.adduserdata = {};
      // this.addusererror = {};
      // this.selected = {};
      // for (const i of this.productList) {
      //   this.selected[i._id] = "none";
      // }
      // this.adduserdialog = true;
    },
    addAccess() {
      this.adduserdata = {};
      this.addusererror = {};
      this.selected = {};
      for (const i of this.productList) {
        this.selected[i._id] = "none";
      }
      this.adduserdialog = true;
    },
    editAccess(item) {
      this.adduserdata = {...item};
      this.addusererror = {};
      this.selected = {};
      for (const i of this.productList) {
        for (const j of i.role) {
          if((this.adduserdata.role || []).indexOf((j._id || "x")) > -1) {
            this.selected[i._id] = j._id;
            break;
          }
          else this.selected[i._id] = "none";
        }
      }
      this.adduserdialog = true;
    },
    editSubscription(item){
      this.selectedproduct = item.product_detail || {};
      this.selectedplan = item.plan_detail || {};
      this.editsubsid = item._id;
      this.addeditsubdialog = true;
    },
    revokeAccess() {
      this.deleteuserloading = true;
      this.axios
        .post("/v2/userpermission/delete/" + this.deleteuserdata._id, {})
        .then((dt) => {
          if (dt.data.status === "success") {
            this.$store.commit("sbSuccess", "User access removed");
            this.deleteuserdialog = false;
            this.refreshData();
          } else throw new Error(dt.data.message || "Error fetching data");
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        })
        .finally(() => {
          this.deleteuserloading = false;
        });
    },
    // provideAccess() {
    //   this.deleteuserloading = true;
    //   this.axios
    //     .post("/v2/client/provideuseraccess/" + this.adduserdata.email, {
    //       client: this.data._id,
    //     })
    //     .then((dt) => {
    //       if (dt.data.status === "success") {
    //         this.$store.commit("sbSuccess", "User access added");
    //         this.adduserdialog = false;
    //         this.refreshData();
    //       } else throw new Error(dt.data.message || "Error fetching data");
    //     })
    //     .catch((err) => {
    //       this.$store.commit("sbError", err.message || err || "Unknown error!");
    //       console.log(err);
    //     })
    //     .finally(() => {
    //       this.deleteuserloading = false;
    //     });
    // },
    addEditAccess() {
      this.adduserloading = true;
      let url = "/v2/userpermission/add";
      let type = "add";
      if(this.adduserdata._id){
        type = "edit";
        url = "/v2/userpermission/edit/" + this.adduserdata._id;
      }
      let accessdata = [];
      for (const k in this.selected) {
        if (Object.hasOwnProperty.call(this.selected, k)) {
          const el = this.selected[k];
          if(el !== 'none') accessdata.push(el);
        }
      }
      this.axios
        .post(url, {
          data: {role: accessdata, email: this.adduserdata.email, client : this.data._id},
        })
        .then((dt) => {
          if (dt.data.status === "success") {
            if(type === "add") this.$store.commit("sbSuccess", "User access added");
            else this.$store.commit("sbSuccess", "User access updated");
            this.adduserdialog = false;
            this.refreshData();
          } else throw new Error(dt.data.message || "Error fetching data");
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        })
        .finally(() => {
          this.adduserloading = false;
        });
    },
    addEditSubscription() {
      this.addeditsubloading = true;
      let url = "/v2/subscription/subscribed/add/";
      let type = "add";
      let newdata = {product: this.selectedproduct._id, plan: this.selectedplan._id};
      if(this.editsubsid){
        type = "edit";
        url = "/v2/subscription/subscribed/edit/" + this.editsubsid;
      }else newdata.client = this.data._id;
      let accessdata = [];
      for (const k in this.selected) {
        if (Object.hasOwnProperty.call(this.selected, k)) {
          const el = this.selected[k];
          if(el !== 'none') accessdata.push(el);
        }
      }
      this.axios
        .post(url, {data: newdata})
        .then((dt) => {
          if (dt.data.status === "success") {
            if(type === "add") this.$store.commit("sbSuccess", "Subscription added");
            else this.$store.commit("sbSuccess", "Subscription updated");
            this.addeditsubdialog = false;
            this.refreshData();
          } else throw new Error(dt.data.message || "Error fetching data");
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        })
        .finally(() => {
          this.addeditsubloading = false;
        });
    },
    enableDisableAccess(id, action, k) {
      this.loading = true;
      let url = "/v2/userpermission/disable/";
      if(action === "enable"){
        url = "/v2/userpermission/enable/"
      }
      this.axios
        .post(url + id, {})
        .then((dt) => {
          if (dt.data.status === "success") {
            if(action === "enable") {
              this.$store.commit("sbSuccess", "User access enabled");
              this.userlist[k].status = true;
            }
            else{
              this.$store.commit("sbSuccess", "User access disabled");
              this.userlist[k].status = false;
            } 
          } else throw new Error(dt.data.message || "Error performing action");
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    enableDisableSubscription(id, action, k) {
      this.loading = true;
      let url = "/v2/subscription/subscribed/disable/";
      if(action === "enable"){
        url = "/v2/subscription/subscribed/enable/"
      }
      this.axios
        .post(url + id, {})
        .then((dt) => {
          if (dt.data.status === "success") {
            if(action === "enable") {
              this.$store.commit("sbSuccess", "Subscription enabled");
              this.subscriptionlist[k].status = true;
            }
            else{
              this.$store.commit("sbSuccess", "Subscription disabled");
              this.subscriptionlist[k].status = false;
            } 
          } else throw new Error(dt.data.message || "Error performing action");
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    validateEntityForm() {
      // Required fields for validation
      const requiredFields = [
        { key: 'name', label: 'Name' },
        { key: 'type', label: 'Type' },
        { key: 'contactperson', label: 'Contact Person' },
        { key: 'contactemail', label: 'Email' },
        { key: 'contactno', label: 'Contact No.' },
        { key: 'industry', label: 'Industry' },
        { key: 'sector', label: 'Sector' },
        { key: 'size', label: 'Size' },
        { key: 'address', label: 'Address' },
      ];
      let valid = true;
      this.errors = {};
      requiredFields.forEach(field => {
        if (!this.modifydata[field.key] || (Array.isArray(this.modifydata[field.key]) && this.modifydata[field.key].length === 0)) {
          this.errors[field.key] = `${field.label} is required`;
          valid = false;
        }
      });
      return valid;
    },
    async update(sodValue) {
      if (!this.validateEntityForm()) {
        return;
      }
      
      if (this.modifydata._id) {
        this.loading = true;
        
        try {
          await this.$store.dispatch('admin/updateClient', {
            axiosInstance: this.axios,
            clientData: this.modifydata,
            clientId: this.modifydata._id
          });
          
          // Handle SOD switch after client update
          if (sodValue !== undefined) {
            try {
              await this.$store.dispatch('admin/switchSod', {
                axiosInstance: this.axios,
                sodData: { sod: sodValue, client_id: this.modifydata._id }
              });
            } catch (sodError) {
              console.error('Error switching SOD setting:', sodError);
            }
          }
          
          this.$store.commit("sbSuccess", "Client Updated");
          this.refreshData();
          
        } catch (error) {
          // Handle validation errors
          if (error.validationErrors) {
            this.errors = error.validationErrors;
          } else {
            this.errors = {};
          }
          
          this.$store.commit(
            "sbError",
            error.message || error || "Unknown error!"
          );
          console.log(error);
        } finally {
          this.loading = false;
        }
      } else {
        console.log("No ID found to update");
      }
    },
    async handleAIEnabledChange(){
      if (this.modifydata.aiEnabled) {
        this.aiEnabledLoading = true;
        try {
          await this.$store.dispatch('admin/initializeClientAIFeatures', {
            axiosInstance: this.axios,
            clientId: this.modifydata._id
          });
        } catch (error) {
          console.error('Error initializing client AI features:', error);
          this.$store.commit('sbError', error.message || error || 'Unknown error!');
        } finally {
          this.aiEnabledLoading = false;
        }
      }
    },
    /**
     * Handle user permission toggle change
     * Dispatches Vuex action to update user_permissions_superadmin status
     */
    async handleUserPermissionChange() {
      this.userPermissionLoading = true;
      const currentStatus = this.modifydata.user_permissions_superadmin;
      
      try {
        // Dispatch Vuex action to update user permissions
        await this.updateUserPermission({
          axiosInstance: this.axios,
          clientData: this.modifydata,
          clientId: this.modifydata._id
        });
        
        // Update the data object locally on success
        this.data.user_permissions_superadmin = currentStatus;
        
        // Update the store flag so other components can access it
        this.$store.commit('setUserPermissionFlag', currentStatus);
        
      } catch (error) {
        console.error('[ClientDetails] Error updating user permissions:', error);
        // Revert the toggle on error
        this.modifydata.user_permissions_superadmin = !currentStatus;
        this.data.user_permissions_superadmin = !currentStatus;
        this.$store.commit('setUserPermissionFlag', !currentStatus);
      } finally {
        this.userPermissionLoading = false;
      }
    },
    async handleSwitchChange() {
      // SOD switch is now handled inside update() to avoid race conditions
      // This handler is kept for backward compatibility if sod-switch is emitted outside of update
      const payload = {
        "sod": this.isEnabled,
        "client_id": this.modifydata._id
      };
      
      try {
        await this.$store.dispatch('admin/switchSod', {
          axiosInstance: this.axios,
          sodData: payload
        });
      } catch (error) {
        console.error('Error switching SOD setting:', error);
        this.$store.commit('sbError', error.message || error || 'Unknown error!');
      }
    },
  },
  computed: {
    breadcrumbs() {
      // Fully dynamic: use route meta or params for Admin and Client, and client name for last
      const route = this.$route;
      const adminText = (route.matched[0] && route.matched[0].meta && route.matched[0].meta.title) ? route.matched[0].meta.title : 'Admin';
      const clientText = (route.matched[1] && route.matched[1].meta && route.matched[1].meta.title) ? route.matched[1].meta.title : 'Client';
      return [
        { text: adminText, disabled: true },
        { text: clientText, disabled: true },
        { text: (this.data && this.data.name) ? this.data.name : 'Details', disabled: true }
      ];
    }
  },
  watch: {
    selectedproduct: function(d){
      // this.selectedplan = {};
      this.possibleplans = [];
      if((d || {})._id){
        for (const i of this.subscriptionplans) {
          if(i.product === (d || {})._id) this.possibleplans.push(i)
        }
      }
    }
  },
};
</script>
